import { styled } from 'stitches.config'

export const BestFriendRoot = styled('div', {
  px: '$8',
  py: '$10',
  backgroundColor: '$secondary-300',
  color: '$primary-800',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  '@bp2': {
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
})

export const Illustration = styled('div', {
  size: '128px',
})

export const TextContainer = styled('div', {
  maxWidth: '519px',
})

export const BestFriendDogContainer = styled('div', {
  width: '256px',
  height: '245px',
  order: 2,
  marginTop: '$5',

  '@bp2': {
    order: 0,
    width: '352px',
    height: '337px',
    marginTop: '0',
  },
})

export const BestFriendFoodContainer = styled('div', {
  width: '328px',
  height: '307px',
})
